import {
	WeaTools
} from 'ecCom'

export const isSettedSecondaryPwd = (params) => {
	return WeaTools.callApi('/api/hrm/secondarypwd/isSettedSecondaryPwd', 'GET', params);
}

export const getPasswordForm = (params) => {
	return WeaTools.callApi('/api/hrm/secondarypwd/getPasswordForm', 'GET', params);
}

export const getSecondaryPwdForm = (params) => {
	return WeaTools.callApi('/api/hrm/secondarypwd/getSecondaryPwdForm', 'GET', params);
}

export const checkPassword = (params) => {
	return WeaTools.callApi('/api/hrm/secondarypwd/checkPassword', 'POST', params);
}

export const saveSecondaryPwd = (params) => {
	return WeaTools.callApi('/api/hrm/secondarypwd/saveSecondaryPwd', 'POST', params);
}

export const checkOldSecondaryPwd = (params) => {
	return WeaTools.callApi('/api/hrm/secondarypwd/checkOldSecondaryPwd', 'POST', params);
}

export const checkNewSecondaryPwd = (params) => {
	return WeaTools.callApi('/api/hrm/secondarypwd/checkNewSecondaryPwd', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/secondaryVerify.js